var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneVerified(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 160,
    viewBox: "0 0 191 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.9548 140H57.7883C53.4869 140 50 136.418 50 132V28C50 23.5817 53.4869 20 57.7883 20H60.9399C56.6465 20.01 53.1665 23.5879 53.1665 28V132C53.1665 136.418 56.6534 140 60.9548 140Z",
    fill: "#1A0826"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.2578 20L60.9399 20C56.6465 20.01 53.1665 23.5879 53.1665 28V132C53.1665 136.418 56.6534 140 60.9548 140L102.212 140C106.513 140 110 136.418 110 132V28C110 23.5817 106.513 20 102.212 20L91.8937 20C91.8937 22.6972 89.8044 24.8837 87.2271 24.8837H75.9245C73.3472 24.8837 71.2578 22.6972 71.2578 20Z",
    fill: "#AA8FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8937 20C91.8937 22.6972 89.8044 24.8837 87.2271 24.8837H75.9245C73.3472 24.8837 71.2578 22.6972 71.2578 20L91.8937 20Z",
    fill: "#1A0826"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9548 140H57.7883C53.4869 140 50 136.418 50 132V28C50 23.5817 53.4869 20 57.7883 20H60.9399M60.9548 140C56.6534 140 53.1665 136.418 53.1665 132V28C53.1665 23.5879 56.6465 20.01 60.9399 20M60.9548 140L102.212 140C106.513 140 110 136.418 110 132V28C110 23.5817 106.513 20 102.212 20L91.8937 20M60.9399 20L71.2578 20M91.8937 20C91.8937 22.6972 89.8044 24.8837 87.2271 24.8837H75.9245C73.3472 24.8837 71.2578 22.6972 71.2578 20M91.8937 20L71.2578 20",
    stroke: "#1A0826",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M135 130.4C135 123.911 137.617 116 149.4 116C142.038 116 135.018 112.535 135 101.6C135 112.049 129.443 116 120.6 116C130.751 116 135 120.779 135 130.4Z",
    fill: "white",
    stroke: "#1A0826",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.175 63.5C76.8316 63.5 72.5 67.8057 72.5 73.1169V78.3787V89.0422V95.75H82.175H91.85V89.0422L91.85 78.3787V73.1169C91.85 67.8057 87.5184 63.5 82.175 63.5ZM82.175 68.3085C84.8467 68.3085 87.0125 70.4613 87.0125 73.1169V78.3787H77.3375V73.1169C77.3375 70.4613 79.5033 68.3085 82.175 68.3085Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5 78.3787H77.3375M72.5 78.3787H91.85M72.5 78.3787V89.0422M72.5 78.3787V73.1169C72.5 67.8057 76.8316 63.5 82.175 63.5C87.5184 63.5 91.85 67.8057 91.85 73.1169V78.3787M91.85 78.3787H87.0125M91.85 78.3787L91.85 89.0422M87.0125 78.3787H77.3375M87.0125 78.3787V73.1169C87.0125 70.4613 84.8467 68.3085 82.175 68.3085C79.5033 68.3085 77.3375 70.4613 77.3375 73.1169V78.3787M91.85 89.0422H72.5M91.85 89.0422V95.75M72.5 89.0422V95.75M91.85 95.75H72.5M91.85 95.75H82.175H72.5",
    stroke: "#1A0826",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.951 78.0622L121 89.1736L134.669 85.5245C146.258 93.8186 164.188 90.2879 171.169 77.3907C177.111 66.4101 173.416 51.7739 162.736 44.841C150.553 36.9377 133.465 41.7762 127.063 54.3645C123.226 61.9037 123.853 70.9824 127.951 78.0622ZM161.966 54.8145L149.293 80.917L136.282 67.6195L138.628 65.1571L148.2 74.075L158.417 53.6099L161.966 54.8145Z",
    fill: "#DCF995"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M149.293 80.917L161.966 54.8145L158.417 53.6099L148.2 74.075L138.628 65.1571L136.282 67.6195L149.293 80.917Z",
    fill: "#1A0826"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.951 78.0622L121 89.1736L134.669 85.5245C146.258 93.8186 164.188 90.2879 171.169 77.3907C177.111 66.4101 173.416 51.7739 162.736 44.841C150.553 36.9377 133.465 41.7762 127.063 54.3645C123.226 61.9037 123.853 70.9824 127.951 78.0622ZM161.966 54.8145L149.293 80.917L136.282 67.6195L138.628 65.1571L148.2 74.075L158.417 53.6099L161.966 54.8145Z",
    stroke: "#1A0826",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M149.293 80.917L161.966 54.8145L158.417 53.6099L148.2 74.075L138.628 65.1571L136.282 67.6195L149.293 80.917Z",
    stroke: "#1A0826",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneVerified);
export default __webpack_public_path__ + "static/media/Phone_Verified.440d8373e7ee3d7b0e381c75011d3fc0.svg";
export { ForwardRef as ReactComponent };